import React, { useMemo } from 'react'
import Select from 'react-select';
import styled from 'styled-components/macro'
import {
  useParams, useHistory, useLocation, matchPath
} from 'react-router-dom'
import { useUserContext } from 'context/UserContext'
import { toast } from 'react-toastify';
import { Toast } from 'containers';
import { useMutation } from 'react-query'
import { archivePage } from 'services/requests'
import { useDispatch } from 'react-redux'
import { deleteDraft } from 'redux/draftsSlice'
import { useEditorContext, actions, status } from 'context/EditorContext';

const PageMenuSelect = () => {
  const {
    subweb, lang, pageId, moduleId
  } = useParams()
  const { pathname } = useLocation()
  const dispatchRedux = useDispatch()
  const [{ pageStatus }, dispatch] = useEditorContext();
  const [archive, { isLoading }] = useMutation(archivePage, {
    onSuccess: () => {
      dispatchRedux(deleteDraft(pageId))
      dispatch({ type: actions.PAGE_ARCHIVE })
      toast.success(
        <Toast
          type="success"
          title="Página ocultada"
          description={`Ocultada a versão ${lang.toUpperCase()}`}
        />
      );
    },
    onError: (err) => {
      toast.error(
        <Toast
          type="error"
          title="Erro a ocultar a página."
          description={err.message}
        />
      );
    }
  })

  const { params: { subEditor } } = useMemo(() => {
    const match = matchPath(pathname, {
      path: '/:subweb/editor/:lang/page/:pageId/:subEditor',
      exact: true,
    });
    return (match && match.isExact) ? match : { params: { subEditor: '' } };
  }, [pathname]);

  const history = useHistory()
  const [{ user }] = useUserContext()

  const handleArchive = () => {
    archive({
      subweb,
      pageId,
      language: lang,
    })
  }

  const options = useMemo(() => {
    const defaultOptions = [
      { label: 'Página', value: '', path: '' },
      { label: 'Histórico', value: 'history', path: '/history' },
      { label: 'Permissões', value: 'permissions', path: '/permissions' },
      {
        label: 'Ocultar', value: 'archive', onClick: handleArchive, isDisabled: pageStatus === status.archive
      },
    ]
    if (user && user.admin) {
      return [
        ...defaultOptions,
        { label: 'Ver JSON', value: 'diff', path: '/diff' },
        { label: 'Editar JSON', value: 'json', path: '/json' }
      ]
    }
    return defaultOptions
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, pageStatus])

  const getOption = (value) => options.find(opt => opt.value === value)

  const currentValue = useMemo(() => {
    const isSeo = moduleId && moduleId.indexOf('SEO') !== -1
    if (isSeo) return getOption('seo')
    return getOption(subEditor)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subEditor, moduleId])

  const handleChange = (option) => {
    if (option && option.onClick && typeof option.onClick === 'function') {
      option.onClick()
    } else {
      const pagePath = `/${subweb}/editor/${lang}/page/${pageId}`
      history.push(`${pagePath}${option.path}`)
    }
  }

  return (
    <SelectStyles>
      <Select
        classNamePrefix="react-select"
        noOptionsMessage={() => 'Sem opções'}
        options={options}
        value={currentValue}
        name="page-menu"
        onChange={handleChange}
        isSearchable={false}
        isLoading={isLoading}
      />
    </SelectStyles>
  )
}

const SelectStyles = styled.div`
  ${props => props.theme.mixins.select()};
`

export default PageMenuSelect
